import { render, staticRenderFns } from "./BBSelect.vue?vue&type=template&id=137aa6db&"
import script from "./BBSelect.vue?vue&type=script&lang=js&"
export * from "./BBSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports